import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type StoreService from '@ember-data/store';
import type InviteModel from 'garaje/models/invite';

export interface DebugWorkflowModel {
  inviteId: string;
  invite: InviteModel | null;
}

export default class VisitorsInvitesDebugWorkflowRoute extends Route {
  @service declare store: StoreService;

  async model(params: { invite_id: string }): Promise<DebugWorkflowModel> {
    let invite: InviteModel | null = null;
    try {
      invite = await this.store.findRecord('invite', params.invite_id);
    } catch {
      // Invite may not be loadable — continue without it
    }
    return { inviteId: params.invite_id, invite };
  }
}
